import { WALLET_MANAGER } from '../global-constants.js';
import { loadScript } from '../utils/loadScript.js';

/**
 * Load the Wallet Manager script bundle
 * @param {string} walletManagerHost - The host URL for the wallet manager
 * @returns {Promise} Resolves when the wallet manager script is loaded
 */
export const loadWalletManager = async (walletManagerHost) => {
	const scriptUrl = `${walletManagerHost}/${WALLET_MANAGER}.js`;
	return loadScript(scriptUrl, { id: 'wallet-manager-bundle' });
}
